import RequireNewPassword from './cognito-require-new-password';
export default RequireNewPassword;
